import {ISearchManager, AbstractSubscriber, AbstractSearchCore, AlgoliaSearchCore, IFacet} from ".";
import {config} from "../../constants";

export class SearchManager implements ISearchManager {
  searchCores: AbstractSearchCore[] = [];

  public async subscribe(subscriber: AbstractSubscriber): Promise<void> {
    let searchCore = this.searchCores.find((value:AbstractSearchCore) => {
      return value.getGroupId() === subscriber.getGroupId();
    });

    const searchConfig: {index: string, defaultQuery: string, defaultFacets: IFacet[]} =
      window?.TJ_SEARCH_CONFIGS?.searchCoreConfigs?.[subscriber.getGroupId()] ??
      window?.TJ_SEARCH_CONFIGS?.searchCoreConfigs?.defaultCoreConfig ??
      {}

    if (!searchCore) {
      searchCore = new AlgoliaSearchCore(subscriber.getGroupId(), {
        appId: config.appId,
        apiKey: config.apiKey,
        indexName: searchConfig?.index || config.indexName,
        defaultQuery: searchConfig?.defaultQuery || "",
        defaultFacets: searchConfig?.defaultFacets || []
      });
      this.searchCores.push(searchCore);
    }

    searchCore.subscribe(subscriber);
  }

  public unsubscribe(subscriber: AbstractSubscriber): void {
    let searchCore = this.searchCores.find((value:AbstractSearchCore) => {
      return value.getGroupId() === subscriber.getGroupId();
    });

    if (!searchCore)
      return;

    searchCore.unsubscribe(subscriber);

    if (searchCore.countSubscribers() <= 0) {
      const index = this.searchCores.indexOf(searchCore);

      if (index !== -1) {
        searchCore.destroy();
        this.searchCores.splice(index, 1);
      }
    }
  }
}
